<div class="container-fluid px-2 px-md-3 px-xl-1 py-3">
  <div class="d-flex flex-column gap-3">
    <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <p class="entity-page-title text-white fw-bold lh-sm mb-1">Roles</p>
            <p class="entity-page-subtitle text-white mb-0 subsystem-subtitle">
              View and manage system roles available for user assignment.
            </p>
          </div>
          <div class="col-auto d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark text-xs d-inline-flex align-items-center rounded-3 px-3 py-2 shadow-sm align-self-end"
              data-bs-toggle="modal"
              data-bs-target="#create_role_modal"
              @click="open_create_role_modal"
            >
              <i class="bi bi-shield-plus me-2 text-white"></i>
              Create Role
            </button>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-3 pb-3">
        <section class="row g-2 entity-config-top-metrics">
          <div class="col-12 col-md-4 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Total Roles
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ roles.length }}</div>
                </div>
                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-person-badge-fill"></i>
                </div>
              </div>
            </article>
          </div>

          <div class="col-12 col-md-4 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Active Roles
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ active_roles_count }}</div>
                </div>
                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-shield-check"></i>
                </div>
              </div>
            </article>
          </div>

          <div class="col-12 col-md-4 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Inactive Roles
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ inactive_roles_count }}</div>
                </div>
                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-shield-x"></i>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    <section class="row g-3">
      <div class="col-12" :class="is_managing_role ? 'col-xl-7' : 'col-xl-12'">
        <section class="entity-inventory-panel rounded-4 border shadow-sm p-2">
          <div class="d-flex align-items-center gap-3 mb-3">
            <div class="entity-section-icon rounded-3 d-inline-flex align-items-center justify-content-center">
              <i class="bi bi-person-badge-fill"></i>
            </div>
            <div class="entity-section-title fw-bold fs-6">System Roles</div>
          </div>

          <div class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide">
            <div class="row g-2 align-items-center">
              <div class="col-lg-4">Role Name</div>
              <div class="col-lg-2">Role ID</div>
              <div class="col-lg-2">Status</div>
              <div class="col-lg-4"></div>
            </div>
          </div>

          <div v-if="is_loading" class="d-flex align-items-center gap-2 text-secondary py-3">
            <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
            <span>Loading roles...</span>
          </div>

          <div v-else-if="roles.length" class="d-flex flex-column gap-2">
            <article
              v-for="role in roles"
              :key="role.id || role.name"
              class="entity-row-card bg-white rounded-4 border shadow-sm p-3"
            >
              <div class="row g-2 align-items-center">
                <div class="col-12 col-lg-4 d-flex align-items-center gap-3">
                  <div class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center">
                    <i class="bi bi-person-badge-fill"></i>
                  </div>
                  <div>
                    <div class="entity-name fw-bold">{{ role.name }}</div>
                    <div class="entity-updated text-secondary small">
                      {{ role.description || 'No description available for this role.' }}
                    </div>
                  </div>
                </div>

                <div class="col-6 col-lg-2 text-secondary small">
                  Role ID: {{ role.id || 'N/A' }}
                </div>

                <div class="col-6 col-lg-2 text-secondary small">
                  {{ role.is_active === false ? 'Inactive' : 'Active' }}
                </div>

                <div class="col-12 col-lg-4 d-flex justify-content-start justify-content-lg-end align-items-center gap-2">
                  <button
                    type="button"
                    class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                    @click="manage_role(role)"
                  >
                    Manage
                  </button>
                  <button
                    type="button"
                    class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                    @click="open_edit_role_modal(role)"
                  >
                    Edit
                  </button>
                </div>
              </div>
            </article>
          </div>

          <div v-else class="bg-white rounded-4 border shadow-sm p-5 text-center">
            <div class="entity-type-icon entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center mb-3">
              <i class="bi bi-person-badge fs-3"></i>
            </div>
            <div class="fw-bold mb-1">No Roles Found</div>
            <div class="text-secondary small">Configured system roles will appear here once they exist.</div>
          </div>
        </section>
      </div>

      <div v-if="is_managing_role && current_role" class="col-12 col-xl-5">
        <section class="entity-detail-panel entity-detail-panel-vibrant rounded-4 border shadow-sm p-3 h-100 mt-1">
          <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
            <div>
              <h2 class="fs-6 fw-bold mb-1">{{ current_role.name }}</h2>
              <div class="small text-secondary">
                {{ current_role.description || 'No role description has been added yet.' }}
              </div>
            </div>
            <button
              type="button"
              class="btn btn-light btn-sm rounded-small border entity-audit-btn"
              @click="close_manage_role"
            >
              Close
            </button>
          </div>

          <div class="d-flex flex-wrap gap-2 mb-3">
            <button
              type="button"
              class="btn btn-sm rounded-small fw-semibold"
              :class="active_role_tab === 'assignments' ? 'btn-primary-dark text-white' : 'entity-assign-btn'"
              @click="toggle_role_tab('assignments')"
            >
              Assignments
            </button>
          </div>

          <div v-if="active_role_tab === 'assignments'" class="d-flex flex-column gap-2">
            <div class="small text-secondary mb-1">
              Select projects that should be associated with this role.
            </div>

            <div v-if="projects_loading" class="d-flex align-items-center gap-2 text-secondary py-2">
              <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
              <span>Loading projects...</span>
            </div>

            <div v-else-if="projects.length" class="d-flex flex-column gap-2">
              <label
                v-for="project in projects"
                :key="project.id"
                class="entity-row-card bg-white rounded-4 border shadow-sm p-3 d-flex align-items-start gap-3"
              >
                <input
                  type="checkbox"
                  class="form-check-input mt-1"
                  :checked="is_project_selected(project.id)"
                  @change="toggle_assignment(project.id)"
                >
                <div class="flex-grow-1">
                  <div class="fw-bold small">{{ project.name }}</div>
                  <div class="text-secondary small">{{ project.description || 'No project description available.' }}</div>
                </div>
              </label>
            </div>

            <div v-else class="text-secondary small">
              No projects are available for assignment yet.
            </div>

            <div class="d-flex justify-content-end pt-2">
              <button
                type="button"
                class="btn btn-primary-dark btn-sm rounded-small shadow text-xs d-inline-flex align-items-center gap-2"
                :disabled="assigning_projects || projects_loading"
                @click="assign_projects_to_role"
              >
                <span
                  v-if="assigning_projects"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                {{ assigning_projects ? 'Saving...' : 'Save Assignments' }}
              </button>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>

  <teleport to="body">
    <div
      class="modal fade"
      id="create_role_modal"
      tabindex="-1"
      aria-labelledby="create_role_modal_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xxs mb-0" id="create_role_modal_label">
              Create Role
            </p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label for="role_name" class="modal-form-label form-label text-xxs">
                Role Name:
              </label>
              <input
                id="role_name"
                v-model="create_form.role_name"
                type="text"
                class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                placeholder="Enter Role Name Here"
              >
            </div>

            <div class="modal-form-group form-group mb-0">
              <label for="role_description" class="modal-form-label form-label text-xxs">
                Description:
              </label>
              <textarea
                id="role_description"
                v-model="create_form.role_description"
                class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                rows="4"
                placeholder="Enter Role Description Here"
              ></textarea>
            </div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm rounded-small shadow text-xs d-inline-flex align-items-center gap-2"
              :disabled="creating_role"
              @click="create_role"
            >
              <span
                v-if="creating_role"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              {{ creating_role ? 'Saving...' : 'Save' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="edit_role_modal"
      tabindex="-1"
      aria-labelledby="edit_role_modal_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xxs mb-0" id="edit_role_modal_label">
              Edit Role
            </p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label for="edit_role_name" class="modal-form-label form-label text-xxs">
                Role Name:
              </label>
              <input
                id="edit_role_name"
                v-model="edit_form.role_name"
                type="text"
                class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                placeholder="Enter Role Name Here"
              >
            </div>

            <div class="modal-form-group form-group mb-0">
              <label for="edit_role_description" class="modal-form-label form-label text-xxs">
                Description:
              </label>
              <textarea
                id="edit_role_description"
                v-model="edit_form.role_description"
                class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                rows="4"
                placeholder="Enter Role Description Here"
              ></textarea>
            </div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark btn-sm rounded-small shadow text-xs d-inline-flex align-items-center gap-2"
              :disabled="updating_role"
              @click="update_role"
            >
              <span
                v-if="updating_role"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              {{ updating_role ? 'Saving...' : 'Save Changes' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</div>
